export const gridTemplatesAreasToString = (
  gridTemplateAreas: Array<Array<string>>,
) =>
  gridTemplateAreas
    .map((rows) => rows.join(' '))
    .map((line) => `'${line}'`)
    .join('\n');
